import { Button, Heading, HFlow, Icon, Modal, ModalBody, ModalFooter, Text, VFlow } from 'bold-ui'
import { useErrorHandler } from 'components/error'
import { FormRenderProps } from 'components/form'
import { useCancelarSolicitacaoEnvioMutation } from 'graphql/hooks.generated'
import React from 'react'

import { EstadoCamposUnificacaoBase } from './ConfiguracoesUnificacaoBaseBox'
import { SolicitacaoEnvioModel } from './SolicitacaoEnvioForm'

interface ModalCancelarSolicitacaoProps {
  isModalOpen: boolean
  setIsModalOpen(isOpen: boolean): void
  solicitacaoId: string
  formSolicitarEnvio: FormRenderProps<SolicitacaoEnvioModel>
  setEstadoCamposForms(estadoCampos: EstadoCamposUnificacaoBase): void
}

export const ModalCancelarSolicitacao = (props: ModalCancelarSolicitacaoProps) => {
  const { isModalOpen, setIsModalOpen, solicitacaoId, formSolicitarEnvio, setEstadoCamposForms } = props
  const handleFecharModal = () => setIsModalOpen(false)
  const handleRejection = useErrorHandler()
  const [cancelarSolicitacaoEnvio] = useCancelarSolicitacaoEnvioMutation()
  const handleCancelarSolicitacao = () => {
    handleFecharModal()
    setEstadoCamposForms({
      isCampoSolicitacaoEnvioAtivo: true,
      isCampoSenhaAtivo: false,
      showBlocoInformativoUnificarBases: false,
    })
    cancelarSolicitacaoEnvio({ variables: { input: { solicitacaoId: solicitacaoId } } }).catch(handleRejection)
    formSolicitarEnvio.form.reset()
    formSolicitarEnvio.form.getRegisteredFields().forEach((field) => formSolicitarEnvio.form.resetFieldState(field))
  }
  return (
    <Modal open={isModalOpen} onClose={handleFecharModal} size='small' closeOnBackdropClick={false} hasCloseIcon={true}>
      <ModalBody>
        <VFlow>
          <HFlow alignItems='flex-start'>
            <Icon icon='infoCircleOutline' fill='info' size={3} />
            <VFlow>
              <Heading level={2}>Deseja cancelar solicitação de envio?</Heading>
              <Text>
                Ao cancelar a solicitação, a instalação destinatária não irá gerar a chave para a unificação de base.
              </Text>
            </VFlow>
          </HFlow>
        </VFlow>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <Button kind='normal' onClick={handleFecharModal}>
            Não, continuar
          </Button>
          <Button kind='primary' onClick={handleCancelarSolicitacao}>
            Sim, cancelar
          </Button>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
